var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagazineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.951,
    height: 31.081,
    viewBox: "0 0 29.951 31.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1.134,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2028",
    "data-name": "Trac\\xE9 2028",
    d: "M-2073.141,2135.967h-8.145a1.95,1.95,0,0,0-.281.028,1.957,1.957,0,0,0-.281-.028h-8.145a6.557,6.557,0,0,0-6.549,6.551V2160.5a6.557,6.557,0,0,0,6.549,6.551h8.145a1.992,1.992,0,0,0,.281-.028,1.985,1.985,0,0,0,.281.028h8.145a6.558,6.558,0,0,0,6.55-6.551v-17.979A6.558,6.558,0,0,0-2073.141,2135.967Zm-19.4,24.53v-17.979a2.554,2.554,0,0,1,2.549-2.551h1.52a11.5,11.5,0,0,1,8.994,4.318,11.646,11.646,0,0,1,2.259,9.84,11.819,11.819,0,0,1-11.709,8.923h-1.064A2.553,2.553,0,0,1-2092.542,2160.5Zm21.951,0a2.553,2.553,0,0,1-2.55,2.551h-5.033a14.934,14.934,0,0,0,4.862-8.068,15.628,15.628,0,0,0-3.051-13.2,15.727,15.727,0,0,0-1.744-1.811h4.966a2.554,2.554,0,0,1,2.55,2.551Z",
    transform: "translate(2096.542 -2135.967)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazineIcon);
export default __webpack_public_path__ + "static/media/magazineIcon.3f4cd91e40772083b71fef9d8c4f90c5.svg";
export { ForwardRef as ReactComponent };